<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-date-picker
          v-model="dateRange"
          align="right"
          size="small"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          value-format="yyyy-MM"
          class="handle-input mr10"
        ></el-date-picker>
        <el-select size="small" v-model="packagesName" clearable filterable placeholder="选择套餐" style="width: 300px;" class="handle-input mr10">
          <el-option :value="null" label="全部套餐"></el-option>
          <el-option v-for="item in packagesOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getData">查询</el-button>
      </div>

      <div v-if="summaryData" class="summary-box">
        <el-card shadow="hover">
          <template v-slot:header>
            <div class="clearfix">
              <span style="font-weight: bold;">汇总数据</span>
            </div>
          </template>
          <div class="summary-row">
            <div class="summary-item">
              <div class="item-label">购买次数</div>
              <div class="item-value">{{ summaryData.totalPurchaseCount }}</div>
            </div>
            <div class="summary-item">
              <div class="item-label">总充值金额</div>
              <div class="item-value">{{ (summaryData.sumTotalRechargeAmount || 0).toFixed(2) }} 元</div>
            </div>
            <div class="summary-item">
              <div class="item-label">总截留金额</div>
              <div class="item-value">{{ (summaryData.sumTotalNeedIntercept || 0).toFixed(2) }} 元</div>
            </div>
            <div class="summary-item">
              <div class="item-label">总到账金额</div>
              <div class="item-value">{{ (summaryData.sumTotalArrivalAmount || 0).toFixed(2) }} 元</div>
            </div>
          </div>
        </el-card>
      </div>

      <el-table
        :key="tableKey"
        :data="tableData"
        border
        class="table"
        max-height="600"
        :row-style="{ height: '20px' }"
        :cell-style="{ padding: '6px' }"
        :header-cell-style="{ 'text-align': 'center' }"
        stripe
        v-loading="loading"
        style="cursor: default;"
      >
        <el-table-column prop="yearMonth" label="月份" width="120" align="center"></el-table-column>
        <el-table-column prop="packagesName" label="套餐名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="packageType" label="套餐类型" width="120" align="center">
          <template #default="scope">
            <span v-if="scope.row.packageType == 0">整月套餐</span>
            <span v-else-if="scope.row.packageType == 1">首月上下半月</span>
            <span v-else>{{ scope.row.packageType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sjtxPriceSnapshot" label="云企通价格(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.sjtxPriceSnapshot !== null ? scope.row.sjtxPriceSnapshot.toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="dxtPriceSnapshot" label="迪信通价格(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.dxtPriceSnapshot !== null ? scope.row.dxtPriceSnapshot.toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="purchaseCount" label="购买次数" width="100" align="center" sortable></el-table-column>
        <el-table-column prop="totalRechargeAmount" label="总充值金额(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.totalRechargeAmount !== null ? scope.row.totalRechargeAmount.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="totalNeedIntercept" label="总截留金额(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.totalNeedIntercept !== null ? scope.row.totalNeedIntercept.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="totalArrivalAmount" label="总到账金额(元)" width="130" align="center" sortable>
          <template #default="scope">
            {{ scope.row.totalArrivalAmount !== null ? scope.row.totalArrivalAmount.toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getAccountStatistics, getDxtPackagesOfNumber } from '../api/dijia.js';

export default {
  name: 'DxtAccountStatistics',
  data() {
    return {
      loading: false,
      theme: localStorage.getItem('theme'),
      dateRange: null,
      packagesName: null,
      packagesOptions: [],
      tableData: [],
      summaryData: null,
      tableKey: 0
    };
  },
  created() {
    this.loadPackages();
  },
  methods: {
    loadPackages() {
      getDxtPackagesOfNumber().then(res => {
        if (res?.code === 200) {
          this.packagesOptions = (res.data || []).map(item => item.packagesName).filter(Boolean);
        }
      });
    },
    getData() {
      this.loading = true;
      const startYearMonth = this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : null;
      const endYearMonth = this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : null;
      getAccountStatistics(startYearMonth, endYearMonth, this.packagesName || null).then(res => {
        if (res?.code === 200) {
          this.tableData = res.data.statistics || [];
          this.summaryData = res.data.summary || null;
          this.tableKey++;
        } else {
          this.$message.error(res.message || '查询失败');
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.$message.error('查询失败');
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.summary-box {
  margin-bottom: 20px;
}

.summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.summary-item {
  flex: 1;
  min-width: 150px;
  text-align: center;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
}

.item-label {
  color: #909399;
  font-size: 14px;
  margin-bottom: 10px;
}

.item-value {
  color: #303133;
  font-size: 20px;
  font-weight: bold;
}
</style>
